import {RestDataLoader} from "../../dashboard/widgets/unilever/RestDataLoader";
import {
    AvailableMassivePatch,
    EquipmentStatus,
    JSONAvailableMassivePatch,
    LockUnlockReasons,
    ValidateEquipment
} from "./MassiveActionsTypesAndFunctions";
import {JSONCensusAvailabilityCheckResult} from "./CensusCooler/data/models/JSONCensusAvailabilityCheckResult";

export function validatesEquipmentsCodes(codes: string[]) {
    return new Promise<ValidateEquipment[]>((res, rej) => {
        RestDataLoader.postJSON(
            `equipment/validation`,
            {list: codes},
            ({validatedElementList}) => res(validatedElementList),
            rej,
        );
    });
}

export function executeMassiveAction(availableMassivePatches: JSONAvailableMassivePatch[]) {
    return new Promise<any>((res, rej) => {
        RestDataLoader.patchJSON(
            `equipment`,
            {list: availableMassivePatches},
            ({validatedElementList}) => res(validatedElementList),
            rej,
        );
    });
}

export function getAvailableMassivePatches() {
    return new Promise<AvailableMassivePatch[]>((res, rej) => {
        RestDataLoader.loadData(
            `equipment/availableMassivePatches`,
            {},
            ({list}) => res(list),
            rej,
        );
    });
}

export const isCensusAvailable = () => {
    return new Promise<JSONCensusAvailabilityCheckResult>((res, rej) => {
        RestDataLoader.loadData(
            `census/isFeatureAvailable`,
            {},
            res,
            rej,
        );
    });
}

export function getLockUnlockReasons() {
    return new Promise<LockUnlockReasons>((res, rej) => {
        RestDataLoader.loadData(
            `equipment/lockReason?lockReason=ALL`,
            {},
            res,
            rej,
        );
    });
}

export function getEquipmentStatuses() {
    return new Promise<EquipmentStatus[]>((res, rej) => {
        RestDataLoader.loadData(
            `equipment/statuses`,
            {},
            ({list}) => res(list),
            rej,
        );
    });
}